import React from 'react';
import { Line } from '@ant-design/plots';
import { Layout } from 'antd';

const HourlyAppUsageChart = ({ data, theme = 'classicDark', chartHeight = 400 }) => {
 
  const accessLevels = ['FREEMIUM', 'SUBSCRIBED', 'GUEST'];
  const completeData = [];
  
  accessLevels.forEach(level => {
    for (let hour = 0; hour < 24; hour++) {
      const existingEntry = data?.find(item => item.hour === hour && item.accessLevel === level);
      completeData.push(existingEntry || { 
        hour, 
        userCount: existingEntry ? existingEntry.userCount : 0, 
        accessLevel: level 
      });
    }
  });
  for (let hour = 0; hour < 24; hour++) {
    let totalUserCount = 0;
   
    completeData
      .filter(item => item.hour === hour && accessLevels.includes(item.accessLevel))
      .forEach(item => {
        totalUserCount += item.userCount;
      });

    completeData.push({
      hour,
      userCount: totalUserCount,
      accessLevel: 'TOTAL' 
    });
  }

  
  const chartData = completeData.map(item => ({
    hour: item.hour,
    category: item.accessLevel,
    value: item.userCount
  }));

  const config = {
    theme,
    data: chartData,
    height: chartHeight,
    xField: 'hour',
    yField: 'value',
    seriesField: 'category',
    colorField: 'category',
    color: ({ category }) => {
      switch(category) {
        case 'FREEMIUM': return '#9E36BB';
        case 'SUBSCRIBED': return '#BB3684';
        case 'GUEST': return '#36BB9C';
        case 'TOTAL': return '#2793F6';
        default: return '#000';
      }
    },
    axis: {
      x: {
        title: false,
        tickCount: 10,
        labelFormatter: (hour) => `${hour}:00`,
        titleStyle: { fill: '#fff' },
        labelStyle: { fill: '#fff' },
      },
      y: {
        title: 'Total No of Users',
        tickCount: 10,
        titleStyle: { fill: '#fff' },
        labelStyle: { fill: '#fff' },
      },
    },
    legend: {
      color: {
        itemMarker: 'dash',
        itemMarkerSize : 12 ,
        position: 'bottom',
        layout: {
          justifyContent: 'center',
        },
        maxRow: 1,
        itemSpacing: 2,
        title: false,
        itemName: {
          style: {
            fill: '#fff',
            fontSize: 12,
            textAlign: 'center',
          },
        },
      },
    },
    
    line: {
      style: {
        lineWidth: 2,
      },
    },
   
    tooltip: {
      showTitle: true,
      title: 'Hour: ${hour}:00',
      items: [
        { field: 'value', name: '' },
      
      ],
      formatter: (datum) => {
        return {
          name: datum.category,
          value: `${datum.value} users`,
        };
      },
    },
    interactions: [
      { type: 'legend-highlight' },
      { type: 'tooltip' }
    ],
  };

  return <Line {...config} />;
};

export default HourlyAppUsageChart;